<template>
  <div>
    <h3>
      {{ $t('phrase.register_research') }}
    </h3>
    <div
      v-if="!researchSubmitMode"
      id="edit-structure"
    >
      <div class="row">
        <div class="col-xl-4 d-none d-xl-block">
          <v-research-general-info
            :research="research"
          />
        </div>
        <div class="col-12 col-xl-8" v-if="organisation">
          <v-research-structure-edit
            v-if="researchType"
            :research="research"
            :organisation="organisation"
            :researchType="researchType"
            :price="price"
            @items-updated="(count) => addedResearchItemsCount = count"
            @next-step="researchSubmitMode = true"
            @research-updated="$emit('research-updated')"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <v-research-submit
        :research="research"
        :organisation="organisation"
        :research-type="researchType"
        :added-research-items-count="addedResearchItemsCount"
        :total-price="price"
        ref="researchSubmit"
        @back="researchSubmitMode = false"
        @joined-competition="addCompetitionFee"
        @submitted="$emit('research-submitted')"
      />
    </div>
  </div>
</template>

<script>
import ResearchStructureEdit from '@/organisation/components/research/ResearchStructureEdit.vue';
import ResearchSubmit from '@/common/components/research/ResearchSubmit.vue';
import ResearchGeneralInfo from '@/common/components/research/ResearchGeneralInfo.vue';
import { fetchOrganisation, fetchResearchType } from '@/organisation/api';

export default {
  name: 'ResearchEdit',
  components: {
    'v-research-general-info': ResearchGeneralInfo,
    'v-research-structure-edit': ResearchStructureEdit,
    'v-research-submit': ResearchSubmit,
  },
  data() {
    return {
      organisation: null,
      addedResearchItemsCount: 0,
      joinedCompetition: false,
      researchType: null,
      researchSubmitMode: false,
    };
  },
  props: {
    research: {
      type: Object,
      required: true,
    },
  },
  computed: {
    price() {
      if (this.researchType && this.researchType.initial_price) {
        const price = this.researchType.initial_price + this.addedResearchItemsCount * 50;
        if (this.joinedCompetition) {
          return price + 100;
        }
        return price;
      }
      return null;
    },
  },
  methods: {
    addCompetitionFee(joinedCompetition) {
      this.joinedCompetition = joinedCompetition;
    },
    fetch() {
      this.$emit('fetch');
    },
    async fetchResearchType() {
      const response = await fetchResearchType(
        this.research.research_type.slug,
        this.research.organisation.slug,
      );
      if (response.status !== 200) {
        this.pageNotFound();
        return;
      }
      this.researchType = response.data;
    },
    async fetchOrganisation() {
      const response = await fetchOrganisation(this.research.organisation.slug);
      if (response.status !== 200) {
        this.pageNotFound();
        return;
      }
      this.organisation = response.data;
    },
  },
  created() {
    this.fetchResearchType();
    this.fetchOrganisation();
  },
};
</script>

<style scoped>
/* Duplication */
.fixed-height {
  height: calc(100vh - 120px);
}
</style>
